module.exports = __webpack_public_path__ + "media/images/flags/64/Slovenia-0a0df029397ba3d28e425110cf6d39a7.png";